<template>
    <section class="hero is-fullheight login" v-show="loginVisible">
        <div class="hero-body">
            <div class="container">
                <div class="columns is-centered">
                    <article class="card is-rounded">
                        <div class="card-content">
                            <h3 class="title">
                                <img src="@/assets/images/logo_mo.png" alt="">
                            </h3>
                              <!--                          <div id="gSignInWrapper">
                              <div class="customGPlusSignIn">
                              <select
                                class="select-css"
                                v-model="locale"
                                @change="onChange()"
                                style="display:block !important"
                              >
                                <option value="ko">KR</option>
                                <option value="en">English</option>
                                
                              </select>
                              </div>
                            </div>   -->
                            <p class="control has-icon">
                                <input v-model="loginInfo.loginId"
                                style = "width : 100%;"
                                autocomplete="name"
                                class="input" type="text" name="username"
                                placeholder="ID" autofocus="">
                                <i class="fa fa-envelope"></i>
                            </p>
                            <p class="control has-icon">
                                <input v-model="loginInfo.loginPw"
                                style = "width : 100%;"
                                autocomplete="new-password"
                                class="input" type="password" name="password"
                                placeholder="PASSWORD" @keydown.enter="login">
                                <i class="fa fa-lock"></i>
                            </p>
                            <p class="control">
                                <button class="button is-fullwidth btn-login" @click="login">{{$t('login')}}</button>
                            </p>
                            <!-- <a :href=googleLoginURL class="btn btn-success active" role="button">Google Login</a>
                            <br>
                            <a href="#" @click="signOut">Sign out</a><br>
                            <br>

                            <div class="g-signin2" data-onsuccess="onSignIn" data-width="320px" data-longtitle="true"></div>
                            <br>

                            <div id="gSignInWrapper">
                              <div id="customBtn" class="customGPlusSignIn">
                                <span class="icon"></span>
                                <span class="buttonText">Log in with Google</span>
                              </div>
                            </div>
                            <div id="gSignInWrapper">
                              <div id="customBtn" class="customGPlusSignIn">
                                <span class="icon"></span>
                                <span class="buttonText">Sign out</span>
                              </div>
                            </div>
                           
                            <br>

                            <a :href=naverLoginURL class="btn btn-success active" role="button"><img src="img/btn/btn_login_with_naver.PNG" width="320px"></a>
                            <br> -->

                        </div>
                    </article>
                </div>
            </div>            
        </div>
                
        <div class="field2 textR_login" style="display:block !important;"> 
        </div>
        <!-- footer -->
        <!-- <div class="footer-login">
            <span class="copyright">COPYRIGHT © CRK Corporation.</span>
        </div> -->
        <footer class="footer">
          <div class="content has-text-centered">
            <span>
              Copyright 2018 LUCOMS Co., Ltd. All Rights Reserved.
            </span>
          </div>
        </footer>
        <!-- //footer-login -->
    </section>
</template>

<script>
export default {
  props: {
    loginId: {
      type: String,
      required: false,
    },
    token: {
      type: String,
      required: false,
    },
  },
  name: 'Login',
  data() {
    return {
      locale: "ko",
      locales: [],      
      loginInfo: {
        loginId: '',
        loginPw: '',
        compCd: '',
          loginDeptNm: '',
          loginDeptCd: '',
          loginJobDutCd: '',
          loginJobDutNm: '',
          loginJobGradeCd: '',
          loginJobGradeNm: '',
        token: '',
        menu: [],
        authorities: [],
        asAgentId : '',
        groupUId : ''
      },
      loginVisible : true,
      //Google
      CLIENT_ID_GOOGLE: '619347127259-nrgl4vcbqul09c2dejg82sjg5sttuthj.apps.googleusercontent.com',
      redirect_uri_google: 'http%3a%2f%2flocalhost%3a8081%2flogin%2foauth2%2fcode%2fgoogle',
      googleLoginURL: 'https://accounts.google.com/o/oauth2/auth?&response_type=code&scope=https://www.googleapis.com/auth/userinfo.email&approval_prompt=force&access_type=offline',

      //Naver
      CLIENT_ID: 'VHjU8KV0izucgnkmB6kM',
      redirectURI: 'http%3a%2f%2flocalhost%3a8081%2flogin%2foauth2%2fcode%2fnaver',
      
      //  FIXME state value random string 으로 변경
      state: '2014dlfwls',
      naverLoginURL: 'https://nid.naver.com/oauth2.0/authorize?response_type=code',
    }
  },
  created() {
    this.loginId = this.$route.query['loginId'];
    this.token = this.$route.query['token'];
    

    this.loginInfo.loginId = this.loginId;
    this.loginInfo.token = this.token;
    

    //[START]운영시스템의 경우 로그인 화면 unvisible ** Open 전날 주석 해제 (6.25)
    // if(process.env.VUE_APP_API_URL.includes("ebiz.carrierkor.co.kr")){
    //   this.loginVisible = false;      

    //   if(window.location.search){
    //     let param  = this.urlArgs();
    //     this.loginInfo.loginId = param.carrierLoginId;
    //     this.loginInfo.loginPw = param.carrierLoginPw;
    //   }else{
    //     window.location.href='http://ebiz.carrierkor.co.kr/';
    //   }

    // }else{
    //   if(window.location.search){
    //     let param  = this.urlArgs();
    //     this.loginInfo.loginId = param.carrierLoginId;
    //     this.loginInfo.loginPw = param.carrierLoginPw;
    //   }
    // }
    

    if(window.location.search){
      let param  = this.urlArgs();
      this.loginInfo.loginId = param.carrierLoginId;
      this.loginInfo.loginPw = param.carrierLoginPw;
    }

    //[END]운영시스템의 경우 로그인 화면 unvisible ** Open 전날 주석 해제 (6.25)

    // eslint-disable-next-line no-unused-vars
    function renderButton() {
      // eslint-disable-next-line no-undef
      gapi.signin2.render('my-signin2', {
        'scope': 'profile email',
        'width': 240,
        'height': 50,
        'longtitle': true,
        'theme': 'dark',
        'onsuccess': onSuccess,
        'onfailure': onFailure
      });
    }
    function onSuccess(googleUser) {
      
      console.log('Logged in as: ' + googleUser.getBasicProfile().getName());
    }
    function onFailure(error) {
      
      console.log(error);
    }

    //모바일 iframe 메시지 수신을 통한 로그인 
    window.addEventListener('message', async event => {
      // console.log(event.data.id);
      if(event.origin === process.env.VUE_APP_MO_URL) {
        // console.log(`pc:event.origin : ${event.origin}`)
        if(event.data.message === 'isPcLogin') {

          const ret = this.$store.state.loginInfo !== null && this.$store.state.token !== '';
          window.parent.postMessage({ 
            message: 'pcLogin', 
            value: ret
          }, '*');
          
          console.log('pc:isPcLogin 수신 후 pcLogin' + ret + '보냄');

        } else if(event.data.message === 'login') {

          
          console.log('pc:login 하라는 메시지 받음');

          if(!this.$store.state.loginInfo) { //로그인 안되어있다면
            this.loginInfo.loginId = event.data.loginId;
            this.loginInfo.loginPw = event.data.loginPw;
            await this.login();        
            const ret = this.$store.state.loginInfo !== null && this.$store.state.token !== '';

            window.parent.postMessage({ 
              message: 'pcLogin', 
              value: ret
            }, '*');
            
            console.log('pc:현재 로그인 안되어있어서 로그인 시키고 pcLogin:' + ret + ' 메시지 보냄');

          } else {
            window.parent.postMessage({ 
              message: 'pcLogin', 
              value: true
            }, '*');
            
            console.log('pc:현재 로그인 되어있어서 pcLogin true 메시지 보냄');
          }
        }
      }
    })

    this.googleLoginURL += '&client_id=' + this.CLIENT_ID_GOOGLE
    this.googleLoginURL += '&redirect_uri=' + this.redirect_uri_google

    this.naverLoginURL += '&client_id=' + this.CLIENT_ID
    this.naverLoginURL += '&redirect_uri=' + this.redirectURI
    this.naverLoginURL += '&state=' + this.state

  },
  beforeMount() {
    // 페이지 리로드를 위해 localStorage에 vuex 제거
    localStorage.removeItem('vuex');
    
    // console.log("this.token : " + this.token);
    // if(this.token) {
    //   if(this.token == "null") {
    //     this.$store.state.oauthNew = 'new';
    //     //this.$router.push({path:`/oauth/new`});
        
    //   } else {
    //     console.log("Now redirect MainPage...")
    //     this.socialLogIn();
    //   }
    // }

    const vInboundTelNo = this.$route.query['InboundTelNo'];
    if(vInboundTelNo){
      this.loginInfo.loginId = this.$route.query['loginId'];
      this.loginInfo.loginPw = this.$route.query['loginPw'];
    }

    if(this.loginInfo.loginId && this.loginInfo.loginPw){
      this.login();
    }
  },
  mounted() {
    this.$i18n.locale = this.locale;
    this.onChange();
  },
  methods: {
    onChange() {      
      this.$i18n.locale = this.locale;
      this.$store.commit("setLocale", this.locale);
      this.$cookie.set("xlocal", this.locale, { expires: 7 });
    },
    loginFail() {
      this.$swal({
        animation: false,
        type: 'error',
        text: `로그인 실패했습니다. ID 또는 비밀번호를 확인해 주세요.`,
      });
    },
    async login() {
      try {
        const vInboundTelNo = this.$route.query['InboundTelNo'];
        
        this.$store.commit('loading');
        const response = await this.$http.post('/api/login', this.loginInfo);
        const loginInfo = {};

        loginInfo.id = response.data.id;
        loginInfo.userName = response.data.userName;
        loginInfo.loginId = response.data.loginId;
        loginInfo.compCd = response.data.loginCompCd;
        loginInfo.loginDeptNm = response.data.loginDeptNm;
        loginInfo.loginDeptCd = response.data.loginDeptCd;
        loginInfo.loginJobDutCd = response.data.loginJobDutCd;
        loginInfo.loginJobDutNm = response.data.loginJobDutNm;
        loginInfo.loginJobGradeCd = response.data.loginJobGradeCd;
        loginInfo.loginJobGradeNm = response.data.loginJobGradeNm;
        loginInfo.token = response.data.token;
        loginInfo.menu = response.data.menu;
        loginInfo.programList = response.data.programList;
        loginInfo.authorities = response.data.authorities;
        loginInfo.asAgentId = response.data.asAgentId;
        loginInfo.groupUId = response.data.groupUId;
        loginInfo.isAdmin = response.data.authorities[0].roleCd === "ADMIN" ? true : false
        loginInfo.isSearchAll = response.data.authorities[0].roleSelectCd === "10" ? true : false //조회권한
        loginInfo.loginPw = 'Not Use';
        this.$store.commit('login', loginInfo);
        this.$cookie.set('loginInfo', JSON.stringify(loginInfo));
        this.$cookie.set('sessionAlive', true);
        this.$http.defaults.headers['x-auth-token'] = loginInfo.token;
        this.$store.commit('register', '');
        this.$store.commit("setLocale", this.locale);

        if(vInboundTelNo){
          const vPath = '/CallMain?InboundTelNo=' + vInboundTelNo;
          this.$router.push({path: vPath});
        } else {
          this.$router.push({path: `/`});
        }
        
        this.$store.commit('finish');
      } catch(err) {
        this.$store.commit('finish');
        this.loginFail();
      }
    },
    signOut() {
      // eslint-disable-next-line no-undef
      var auth2 = gapi.auth2.getAuthInstance();
      auth2.signOut().then(function () {
        
        console.log('User signed out.');
      });
    },
    async socialLogIn() {
      
      console.log("Now Loged in!!!!")
      try {
        this.$store.commit('loading');
        const response = await this.$http.post('/api/login', this.loginInfo);
        const loginInfo = {};

        loginInfo.id = response.data.id;
        loginInfo.userName = response.data.userName;
        loginInfo.loginId = response.data.loginId;
        loginInfo.compCd = response.data.loginCompCd;
        loginInfo.loginDeptNm = response.data.loginDeptNm;
        loginInfo.loginDeptCd = response.data.loginDeptCd;
        loginInfo.loginJobDutCd = response.data.loginJobDutCd;
        loginInfo.loginJobDutNm = response.data.loginJobDutNm;
        loginInfo.loginJobGradeCd = response.data.loginJobGradeCd;
        loginInfo.loginJobGradeNm = response.data.loginJobGradeNm;
        loginInfo.token = response.data.token;
        loginInfo.menu = response.data.menu;
        loginInfo.authorities = response.data.authorities;
        loginInfo.loginPw = 'Not Use';

        this.$store.commit('login', loginInfo);
        this.$cookie.set('loginInfo', JSON.stringify(loginInfo));
        this.$cookie.set('sessionAlive', true);
        this.$http.defaults.headers['x-auth-token'] = loginInfo.token;
        this.$store.commit('register', '');
        this.$router.push({path: `/`});        
        this.$store.commit('finish');
      } catch(err) {
        this.$store.commit('finish');
        this.loginFail();
      }
    }, 
    urlArgs(){
      // 빈 객체를 선언한다.
      var args = { };
      
      // 쿼리스트링을 얻어온 후 '?' 를 제거한다.
      var query = window.location.search.substring(1);
      
      // & 문자열을 기준 삼아 배열로 분리한다.
      var pairs = query.split("&");
      
      // 분리된 부분마다
      for(var i = 0; i<pairs.length; i++) {
        // '이름=값' 패턴을 찾는다.
        var pos = pairs[i].indexOf('=');
        // 찾을 수 없다면 스킵한다.
        if(pos === -1) {continue;}
        // 이름을 추출한다.
        var name = pairs[i].substring(0,pos);
        // 값을 추출한다.
        var value = pairs[i].substring(pos+1);
        // 값을 해석한다.
        value = decodeURIComponent(value);
        // 프로퍼티로 저장한다.
        args[name] = value;}
        // 추출된 전달인자들을 반환한다.
        return args;
    }
  },
  
};
</script>

<style scoped>
footer {
  bottom: 0; background:#404040;
}
footer span {
  color:#fff; font-family:'NotoM'; opacity:.5;
}
</style>